import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}><g fill="none" fillRule="evenodd"><circle cx="12" cy="12" r="11" fill="#FFF" stroke="#039B03" strokeWidth="2" /><path d="M15.494 8.258a.884.884 0 011.248 1.248L11.447 14.8a.88.88 0 01-1.247 0l-2.942-2.94a.884.884 0 011.248-1.249l2.318 2.319 4.67-4.67z" fill="#039B03" fillRule="nonzero" /></g></svg>);